'use strict';

var React = require('react');

var SvgViewportWideMajor = function SvgViewportWideMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m16.707 6.293 3 3a.998.998 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.631-.324 1 1 0 0 1 .217-1.09l1.293-1.293h-4.586a1 1 0 1 1 0-2h4.586l-1.293-1.293a1 1 0 1 1 1.414-1.414zm-13.414 0a1 1 0 1 1 1.414 1.414l-1.293 1.293h4.586a1 1 0 0 1 0 2h-4.586l1.293 1.293a1.003 1.003 0 0 1 0 1.414 1 1 0 0 1-1.414 0l-3-3a.998.998 0 0 1 0-1.414l3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 1.5a1.5 1.5 0 0 1 1.5-1.5h15a1.5 1.5 0 0 1 1.5 1.5v4.5l-2-2v-2h-14v2l-2 2v-4.5zm16 16.5v-2l2-2v4.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-4.5l2 2v2h14z"
  }));
};

exports.SvgViewportWideMajor = SvgViewportWideMajor;
